module.exports = __webpack_public_path__ + "static/media/nabor.5028dbab.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/images/nabor.png
// module id = 1123
// module chunks = 0